<template>
    <div class="info">
        <div class="table-wrap">
            <div class="headtable-top">
                <h4 class="title02"><span>작성일</span><span>{{$commonUtils.makeDateFormat(painDate, '-')}}</span></h4>
                <p><span class="c-red">*</span> 표시는 필수 입력 항목입니다.</p>
            </div>
            <div class="table headtable">
                <table>
                    <colgroup>
                        <col style="width:25%;">
                        <col style="width:25%;">
                        <col style="width:25%;">
                        <col style="width:25%;">
                    </colgroup>
                    <tbody>
                        <tr>
                            <th><h4 class="title03"><span class="c-red">*</span> 시작시간</h4></th>
                            <td>
                                <div class="headtable-time">
                                    <div class="headtable-time__item">
                                        <a href="javascript:;" class="top" @click="addHour('startHour', 1)"></a>
                                        <input type="text" maxlength="2" value="00" v-model="headNote.startHour"/>
                                        <a href="javascript:;" class="bottom" @click="addHour('startHour', -1)"></a>
                                    </div>
                                    <div class="headtable-time__item">
                                        <p>:</p>
                                    </div>
                                    <div class="headtable-time__item">
                                        <a href="javascript:;" class="top" @click="addMinute('startMinute', 1)"></a>
                                        <input type="text" maxlength="2" value="00" v-model="headNote.startMinute"/>
                                        <a href="javascript:;" class="bottom" @click="addMinute('startMinute', -1)"></a>
                                    </div>
                                </div>
                            </td>
                            <th><h4 class="title03"><span class="c-red">*</span> 종료시간</h4></th>
                            <td>
                                <div class="headtable-time">
                                    <div class="headtable-time__item">
                                        <a href="javascript:;" class="top" @click="addHour('endHour', 1)"></a>
                                        <input type="text" maxlength="2" value="00" v-model="headNote.endHour"/>
                                        <a href="javascript:;" class="bottom" @click="addHour('endHour', -1)"></a>
                                    </div>
                                    <div class="headtable-time__item">
                                        <p>:</p>
                                    </div>
                                    <div class="headtable-time__item">
                                        <a href="javascript:;" class="top" @click="addMinute('endMinute', 1)"></a>
                                        <input type="text" maxlength="2" value="00" v-model="headNote.endMinute"/>
                                        <a href="javascript:;" class="bottom" @click="addMinute('endMinute', -1)"></a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <h4 class="title03"><span class="c-red">*</span> 통증 부위</h4>
                                <sub>(다중 선택 가능)</sub>
                            </th>
                            <td colspan="3">
                                <ul class="headtable__area">
                                    <li class="headtable__area--front">
                                        <p class="left">우측</p>
                                        <p class="right">좌측</p>
                                        <div class="headtable__area--img">
                                            <img src="@/assets/resource/img/headtable__area--front.png" alt="">
                                            <template v-for="option in areaOptions.slice(0,10)" :key="option">
                                                <label for="" class="headtable__area--check" :class="getCheckClass(option)">
                                                    <input type="checkbox" v-model="headNote.painAreaTemp" :value="option">
                                                    <span></span>
                                                </label>
                                            </template>
                                        </div>
                                    </li>
                                    <li class="headtable__area--back">
                                        <p class="left">좌측</p>
                                        <p class="right">우측</p>
                                        <div class="headtable__area--img">
                                            <img src="@/assets/resource/img/headtable__area--back.png" alt="">
                                            <template v-for="option in areaOptions.slice(10,18)" :key="option">
                                                <label for="" class="headtable__area--check" :class="getCheckClass(option)">
                                                    <input type="checkbox" v-model="headNote.painAreaTemp" :value="option">
                                                    <span></span>
                                                </label>
                                            </template>
                                        </div>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <th><h4 class="title03"><span class="c-red">*</span> 통증 강도</h4></th>
                            <td colspan="3" class="left">
                                <div class="headtable__strength">
                                    <ul class="headtable__strength__number">
                                        <li>1</li>
                                        <li>2</li>
                                        <li>3</li>
                                        <li>4</li>
                                        <li>5</li>
                                        <li>6</li>
                                        <li>7</li>
                                        <li>8</li>
                                        <li>9</li>
                                        <li>10</li>
                                    </ul>
                                    <ul class="headtable__strength__input radio-wrap">
                                        <li>
                                            <label  >
                                                <input type="radio" name="test01" id="test01" value="1" v-model="headNote.painLevel">
                                                <span class="radio-btn"></span>
                                            </label>
                                        </li>
                                        <li>
                                            <label  >
                                                <input type="radio" name="test01" id="test02" value="2" v-model="headNote.painLevel">
                                                <span class="radio-btn"></span>
                                            </label>
                                        </li>
                                        <li>
                                            <label  >
                                                <input type="radio" name="test01" id="test03" value="3" v-model="headNote.painLevel" >
                                                <span class="radio-btn"></span>
                                            </label>
                                        </li>
                                        <li>
                                            <label  >
                                                <input type="radio" name="test01" id="test04" value="4" v-model="headNote.painLevel" >
                                                <span class="radio-btn"></span>
                                            </label>
                                        </li>
                                        <li>
                                            <label  >
                                                <input type="radio" name="test01" id="test05" value="5" v-model="headNote.painLevel" >
                                                <span class="radio-btn"></span>
                                            </label>
                                        </li>
                                        <li>
                                            <label  >
                                                <input type="radio" name="test01" id="test06" value="6" v-model="headNote.painLevel" >
                                                <span class="radio-btn"></span>
                                            </label>
                                        </li>
                                        <li>
                                            <label  >
                                                <input type="radio" name="test01" id="test07" value="7" v-model="headNote.painLevel" >
                                                <span class="radio-btn"></span>
                                            </label>
                                        </li>
                                        <li>
                                            <label  >
                                                <input type="radio" name="test01" id="test08" value="8" v-model="headNote.painLevel" >
                                                <span class="radio-btn"></span>
                                            </label>
                                        </li>
                                        <li>
                                            <label  >
                                                <input type="radio" name="test01" id="test09" value="9" v-model="headNote.painLevel" >
                                                <span class="radio-btn"></span>
                                            </label>
                                        </li>
                                        <li>
                                            <label  >
                                                <input type="radio" name="test01" id="test10" value="10" v-model="headNote.painLevel" >
                                                <span class="radio-btn"></span>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <p><span class="c-red">*</span> 1~3단계:약한통증 / 4~6단계:보통통증 / 7~9단계:강한통증 / 10단계:극심한통증(상상할 수 있는 가장 심한 통증)</p>
                            </td>
                        </tr>

                        <tr>
                            <th><h4 class="title03"><span class="c-red">*</span> 통증 유형</h4></th>
                            <td colspan="3">
                                <ul class="head-symptom__list">
                                    <template v-for="option in painType" :key="option">
                                        <li>
                                            <label :for="'head'+option.value">
                                                <input type="radio" v-model="headNote.painType" :value="option.value" :id="'head'+option.value"/>
                                                <a href="javascript:;">
                                                    <div class="icon" :class="`head-${option.value === 'etc' ? 'etc' : 'type' + option.value}`"></div>
                                                    <p>{{ option.label }}</p>
                                                </a>
                                            </label>
                                        </li>
                                    </template>
                                </ul>
                                <template v-if="headNote.painType === 'etc'">
                                    <input type="text" class="head-symptom__input" v-model="headNote.painTypeEtc" maxlength="100">
                                    <p class="head-symptom__input--text">{{headNote.painTypeEtc.length}}/100</p>
                                </template>
                            </td>
                        </tr>

                        <tr>
                            <th><h4 class="title03">추가 특이사항</h4></th>
                            <td colspan="3" class="left">
                                <ul class="radio-wrap symptom">
                                    <template v-for="option in extraOption" :key="option">
                                        <li>
                                            <label :for="'extra'+option.value">
                                                <input type="checkbox" v-model="headNote.extraOptionTemp" :value="option.value" :id="'extra'+option.value"/>
                                                <span class="radio-btn"></span>
                                                <p>{{ option.label }}</p>
                                            </label>
                                        </li>
                                    </template>
                                </ul>
                                <p class="mt10"><span class="c-red">*</span> 작성하실 항목을 모두 선택해주세요.</p>
                            </td>
                        </tr>

                        <tr v-if="headNote.extraOptionTemp.includes('01')">
                            <th>
                                <h4 class="title03">두통 전조 증상</h4>
                                <sub>(다중 선택 가능)</sub>
                            </th>
                            <td colspan="3">
                                <ul class="head-symptom__list">
                                    <template v-for="option in aura" :key="option">
                                        <li>
                                            <label :for="'aura'+option.value">
                                                <input type="checkbox" v-model="headNote.auraTemp" :value="option.value" :id="'aura'+option.value"/>
                                                <a href="javascript:;">
                                                    <div class="icon" :class="`head-${option.value === 'etc' ? 'etc' : 'aura' + option.value}`"></div>
                                                    <p>{{ option.label }}</p>
                                                </a>
                                            </label>
                                        </li>
                                    </template>
                                </ul>
                                <template v-if="headNote.auraTemp.includes('etc')">
                                    <input type="text" class="head-symptom__input" v-model="headNote.auraEtc" maxlength="100" >
                                    <p class="head-symptom__input--text">{{headNote.auraEtc.length}}/100</p>
                                </template>
                            </td>
                        </tr>
                        <tr v-if="headNote.extraOptionTemp.includes('02')">
                            <th>
                                <h4 class="title03">두통 중 동반 증상</h4>
                                <sub>(다중 선택 가능)</sub>
                            </th>
                            <td colspan="3">
                                <ul class="head-symptom__list">
                                    <template v-for="option in painSymptom" :key="option">
                                        <li>
                                            <label :for="'with'+option.value">
                                                <input type="checkbox" v-model="headNote.painSymptomTemp" :value="option.value" :id="'with'+option.value"/>
                                                <a href="javascript:;">
                                                    <div class="icon" :class="`head-${option.value === 'etc' ? 'etc' : 'with' + option.value}`"></div>
                                                    <p>{{ option.label }}</p>
                                                </a>
                                            </label>
                                        </li>
                                    </template>
                                </ul>
                                <template v-if="headNote.painSymptomTemp.includes('etc')">
                                    <input type="text" class="head-symptom__input" v-model="headNote.painSymptomEtc" maxlength="100">
                                    <p class="head-symptom__input--text">{{headNote.painSymptomEtc.length}}/100</p>
                                </template>
                            </td>
                        </tr>
                        <tr v-if="headNote.extraOptionTemp.includes('03')">
                            <th>
                                <h4 class="title03">두통 유발 요인</h4>
                                <sub>(다중 선택 가능)</sub>
                            </th>
                            <td colspan="3">
                                <ul class="head-symptom__list">
                                    <template v-for="option in painCauses" :key="option">
                                        <li>
                                            <label :for="'factor'+option.value">
                                                <input type="checkbox" v-model="headNote.painCausesTemp" :value="option.value" :id="'factor'+option.value"/>
                                                <a href="javascript:;">
                                                    <div class="icon" :class="`head-${option.value === 'etc' ? 'etc' : 'factor' + option.value}`"></div>
                                                    <p>{{ option.label }}</p>
                                                </a>
                                            </label>
                                        </li>
                                    </template>
                                </ul>
                                <template v-if="headNote.painCausesTemp.includes('etc')">
                                    <input type="text" class="head-symptom__input" v-model="headNote.painCausesEtc" maxlength="100">
                                    <p class="head-symptom__input--text">{{headNote.painCausesEtc.length}}/100</p>
                                </template>
                            </td>
                        </tr>
                        <tr v-if="headNote.extraOptionTemp.includes('04')">
                            <th>
                                <h4 class="title03">두통 완화 조치</h4>
                                <sub>(다중 선택 가능)</sub>
                            </th>
                            <td colspan="3">
                                <ul class="head-symptom__list">
                                    <template v-for="option in reliefAction" :key="option">
                                        <li>
                                            <label :for="'mitigation'+option.value">
                                                <input type="checkbox" v-model="headNote.reliefActionTemp" :value="option.value" :id="'mitigation'+option.value"/>
                                                <a href="javascript:;">
                                                    <div class="icon" :class="`head-${option.value === 'etc' ? 'etc' : 'mitigation' + option.value}`"></div>
                                                    <p>{{ option.label }}</p>
                                                </a>
                                            </label>
                                        </li>
                                    </template>
                                </ul>
                                <template v-if="headNote.reliefActionTemp.includes('etc')">
                                    <input type="text" class="head-symptom__input" v-model="headNote.reliefActionEtc" maxlength="100">
                                    <p class="head-symptom__input--text">{{headNote.reliefActionEtc.length}}/100</p>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <th><h4 class="title03">기타 메모</h4></th>
                            <td colspan="3">
                                <textarea name="" v-model="headNote.etcMemo"></textarea>
                                <p class="head-symptom__input--text">{{headNote.etcMemo.length}}/500</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="botton-wrap nowrap">
            <a href="javascript:;" class="sub-button c-gray" @click="cancelWrite" >취소</a>
            <a href="javascript:;" class="main-button c-main" @click="openAgreePopup">등록</a>
        </div>
    </div>

    <kr_AgreePopUp @hide-popup="hidePopup" @confirm="insertHeadNote" v-if="agreePopup" />
</template>

<script>
export default {
    name: 'SampleComponent',
    components: {
    },
    data() {
        return {
            headNote: {
                painAreaTemp: [],
                etcMemo: '',
                painLevel: '1',
                painDate: this.$route.query.painDate,
                painSymptomTemp: [],
                auraTemp: [],
                painCausesTemp: [],
                reliefActionTemp: [],
                painTypeEtc: '',
                auraEtc: '',
                painCausesEtc: '',
                reliefActionEtc: '',
                painSymptomEtc: '',
                extraOptionTemp: [],
                startHour: '00',
                startMinute: '00',
                //endHour, minute는 현재 시간
                endHour: new Date().getHours().toString().length < 2 ? `0${new Date().getHours()}` : new Date().getHours(),
                endMinute: new Date().getMinutes().toString().length < 2 ? `0${new Date().getMinutes()}` : new Date().getMinutes()
            },
            //params painDate 받아옴
            painDate: this.$route.query.painDate,
            areaOptions: Array.from({ length: 18 }, (_, index) => index + 1),
            extraOption: [
                { label: '두통 전조 증상', value: '01' },
                { label: '두통 중 동반증상', value: '02' },
                { label: '두통 유발 요인', value: '03' },
                { label: '두통 완화 조치', value: '04' },
            ],
            painSymptom: [
                { label: '울렁거림', value: '01' },
                { label: '구토', value: '02' },
                { label: '어지럼증', value: '03' },
                { label: '움직임에 의한 악화', value: '04' },
                { label: '시야가 흐릿함', value: '05' },
                { label: '이명', value: '06' },
                { label: '안구통', value: '07' },
                { label: '기타', value: 'etc' }
            ],
            painType: [
                { label:'욱신거림', value: '01' },
                { label:'깨질듯', value: '02' },
                { label:'쥐어짜듯', value: '03' },
                { label:'터질듯함', value: '04' },
                { label:'찌르는듯', value: '05' },
                { label:'기타', value: 'etc' }
            ],
            aura: [
                { label:'아플 것 같은 느낌', value: '01' },
                { label:'어깨 뻐근함', value: '02' },
                { label:'하품', value: '03' },
                { label:'피로', value: '04' },
                { label:'소화장애', value: '05' },
                { label:'빛·소리 민감', value: '06' },
                { label:'기타', value: 'etc' }
            ],
            painCauses: [
                { label:'스트레스', value: '01' },
                { label:'수면부족', value: '02' },
                { label:'늦잠', value: '03' },
                { label:'굶음', value: '04' },
                { label:'냄새', value: '05' },
                { label:'음주', value: '06' },
                { label:'월경', value: '07' },
                { label:'성관계', value: '08' },
                { label:'운동', value: '09' },
                { label:'소화불량', value: '10' },
                { label:'기타', value: 'etc' }
            ],
            reliefAction: [
                { label:'휴식', value: '01' },
                { label:'수면', value: '02' },
                { label:'요가/명상', value: '03' },
                { label:'마사지', value: '04' },
                { label:'약', value: '05' },
                { label:'기타', value: 'etc' }
            ],
            agreePopup: false
        };
    },
    methods: {
        getCheckClass(option) {
            const className = option < 10 ? `check0${option}` : `check${option}`;
            return className;
        },
        openAgreePopup() {
            if(this.headNote.startHour.length < 2 || this.headNote.startMinute.length < 2 || this.headNote.endHour.length < 2 || this.headNote.endMinute.length < 2){
                alert('시간을 입력해주세요')
                return
            }

            //통증 부위, 통증유형 validation
            if(this.headNote.painAreaTemp.length === 0){
                alert('통증 부위를 선택해주세요')
                return
            }

            if(!this.headNote.painType){
                alert('통증 유형을 선택해주세요')
                return
            }

            this.agreePopup = true
        },
        hidePopup() {
            this.agreePopup = false
        },
        insertHeadNote() {

            this.headNote.painStartTime = `${this.headNote.startHour}${this.headNote.startMinute}`
            this.headNote.painEndTime = `${this.headNote.endHour}${this.headNote.endMinute}`
            this.headNote.painArea = this.headNote.painAreaTemp.join(',')
            this.headNote.aura = this.headNote.auraTemp.join(',')
            this.headNote.painCauses = this.headNote.painCausesTemp.join(',')
            this.headNote.reliefAction = this.headNote.reliefActionTemp.join(',')
            this.headNote.painSymptom = this.headNote.painSymptomTemp.join(',')
            this.headNote.extraOption = this.headNote.extraOptionTemp.join(',')

            if(this.headNote.brSeq){
                this.axios.post(this.api.mypage.headNoteUpdate, null, {
                    params: this.headNote
                }).then(res => {
                    this.$router.push({ path: '/kr/mypage/headNote' })
                })
            }else{
                this.axios.post(this.api.mypage.headNoteReg, null, {
                    params: this.headNote
                }).then(res => {
                    this.$router.push({ path: '/kr/mypage/headNote' })
                })
            }

            alert('두통기록이 저장되었습니다.')
        },
        addHour(target, num) {
            let temp = parseInt(this.headNote[target]) + num
            if(temp < 0){
                temp = 0
            }else if(temp > 23){
                temp = 23
            }

            this.headNote[target] = temp.toString().length < 2 ? `0${temp}` : temp
        },
        addMinute(target, num) {
            let temp = parseInt(this.headNote[target]) + num
            if(temp < 0){
                temp = 0
            }else if(temp > 59){
                temp = 59
            }
            this.headNote[target] = temp.toString().length < 2 ? `0${temp}` : temp
        },
        cancelWrite() {
            if(confirm('작성을 취소하시겠습니까?')) {
                this.$router.push({path: '/kr/mypage/headNote'})
            }
        }
    },
    mounted() {
        //
        if(this.$route.query.brSeq){
            const brSeq = this.$route.query.brSeq

            this.axios.get(this.api.mypage.headNote, {
                params: {
                    brSeq: brSeq
                }
            }).then(res => {
                this.headNote = res.data

                this.headNote.painAreaTemp = this.headNote.painArea ? this.headNote.painArea.split(',') : []
                this.headNote.auraTemp = this.headNote.aura ? this.headNote.aura.split(',') : []
                this.headNote.painCausesTemp = this.headNote.painCauses ? this.headNote.painCauses.split(',') : []
                this.headNote.reliefActionTemp = this.headNote.reliefAction ? this.headNote.reliefAction.split(',') : []
                this.headNote.painSymptomTemp = this.headNote.painSymptom ? this.headNote.painSymptom.split(',') : []
                this.headNote.extraOptionTemp = this.headNote.extraOption ? this.headNote.extraOption.split(',') : []

                this.headNote.startHour = this.headNote.painStartTime.substring(0,2)
                this.headNote.startMinute = this.headNote.painStartTime.substring(2,4)
                this.headNote.endHour = this.headNote.painEndTime.substring(0,2)
                this.headNote.endMinute = this.headNote.painEndTime.substring(2,4)
            })

        }

    },
}
</script>

<style scoped></style>